import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Divider, Popconfirm, Row } from 'antd'
import MainLayout from 'Hoc/MainLayout'
import Loader from 'Components/Loader'
import Summary from 'Components/Summary'
import Purpose from 'Components/Purpose'
import HandleAgreementModal from 'Components/HandleAgreementModal'
import { AlignRightColumn, MarginLeftButton } from 'Common/styled'

import api from 'Common/api'
import { agreementState, userType } from 'Common/constants'

import { connect } from 'react-redux'
import { updateAgreementPurposes, updateSelectedAgreement, updateSelectedRefs } from 'Actions/agreement-actions'
import { isEmptyObject } from '../../common/utils'

import * as _ from 'lodash'
import { updateUser } from '../../redux-store/actions/user-actions'
import MidMsgComponent from '../Dashboard'

class Agreement extends Component {
  state = {
    loading: false,
    isModalOpen: false,
    sendToSupplierStep: 0
  }

  componentWillMount() {
    if (sessionStorage.getItem('token') !== null) {
      api.auth.decode().then(response => {
        window.backendApplicationVersion = response.data.applicationVersion ?
          response.data.applicationVersion : window.backendApplicationVersion ?
            window.backendApplicationVersion : null;
        this.props.updateUser({data: response.data, type: response.data.userType});
      }).catch(err => {
        console.error(err);
        this.props.updateUser({data: null, type: null});
      })
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params

    if (isEmptyObject(this.props.selectedAgreement)) {
      this.viewAgreement(id)
    }
  }

  sendToSupplier = () => {
    const agreement = this.props.selectedAgreement
    // Change state from DRAFT to OPEN_WAITING
    agreement.agreementState = agreementState[1].key
    // Save updated agreement on DB
    this.changeState(agreement)
  }

  viewAgreement = id => {
    // Loading while fetching
    this.setState({ loading: true })
    // Axios GET call, fetch a single agreement passing the id
    const params = {};

    if (_.get(this.props, ['user', 'type'], null) === userType.AM.key) {
      params.storeId = _.get(this.props, ['user', 'storeId'], 12);
    }

    api.agreements
      .getOne(id, params)
      .then(res => {
        // Stop loading
        this.setState({ loading: false })

        // Save result on Redux store
        this.props.updateSelectedAgreement(res.data)
        this.props.updateSelectedRefs(res.data.agreementDetails)
      })
      .catch(err => {
        console.error(err)
        // Stop loading
        this.setState({ loading: false })
      })
  }

  handleAgreement = value => {
    const agreement = this.props.selectedAgreement
    // Check user type
    const isSupplier = this.props.user.type === userType.S.key
    if (value === 'REFUSE') {
      // If supplier change state from OPEN_WAITING to CLOSED_REJECTED_SUPPLIER
      // If PM change state from OPEN_APPROVED to CLOSED_REJECTED_PRODUCT_OWNER
      agreement.agreementState = agreementState[isSupplier ? 4 : agreement.asProposal ? 7 : 5].key
    } else {
      // If supplier change state from OPEN_WAITING to OPEN_APPROVED
      // If PM change state from OPEN_APPROVED to CLOSED_APPROVED_FORWARDED
      if (value === 'ACCEPT_TRASH' && isSupplier) {
        agreement.trash = true;
      }

      agreement.agreementState = agreementState[isSupplier ? 2 : agreement.asProposal ? 8 : 3].key
    }
    // Save updated agreement on DB
    this.changeState(agreement)
  }

  changeState = updatedAgreement => {
    // Loading while saving
    this.setState({ loading: true })
    // Axios PUT call, update state on DB
    api.agreements
      .edit(updatedAgreement)
      .then(res => {
        // Save result on store
        this.props.updateSelectedAgreement(res.data)
        // Stop loading and close modal
        this.setState({ loading: false, isModalOpen: false })
      })
      .catch(err => {
        console.error(err)
        // Stop loading and close modal
        this.setState({ loading: false, isModalOpen: false })
      })
  }

  openModal = () => this.setState({ isModalOpen: true })

  closeModal = () => this.setState({ isModalOpen: false })

  canSeePurposes() {
    return this.props.selectedAgreement.agreementState === 'CLOSED_APPROVED_FORWARDED' ||
      this.props.selectedAgreement.agreementState === 'CLOSED_APPROVED_AREA_MANAGER'
  }

  updatePurpose = (values, purposeId) => {
    const selectedAgreement = Object.assign({}, this.props.selectedAgreement)
    selectedAgreement.proposals = values

    this.props.updateAgreementPurposes(selectedAgreement)
  }

  updateConnections(connections) {
    api.purposes.updateConnections(connections).then(res => {
      this.setState({loading: false});
    }).catch(err => {
      console.error(err);
      this.setState({loading: false});
    })
  }

  render() {
    if (this.props.user.type === null) {
      return <MidMsgComponent title={'PAGINA NON ACCESSIBILE'} description={'L\'applicazione è accessibile soltanto attraverso i canali di autenticazione.'}/>
    }

    const { selectedAgreement, user } = this.props
    const { loading, isModalOpen } = this.state
    // Check user type
    const isPm = user.type === userType.PM.key
    const isSupplier = user.type === userType.S.key
    const isAm = user.type === userType.AM.key;
    // Check agreement state
    const isDraft = selectedAgreement.agreementState === agreementState[0].key
    const isOpenWaiting =
      selectedAgreement.agreementState === agreementState[1].key
    const isOpenApproved =
      selectedAgreement.agreementState === agreementState[2].key
    const asProposal = selectedAgreement.asProposal === true;
    const isAgreementOwner = selectedAgreement.userName === _.get(user, 'data.id', null);
    const isAgreementSupplier = _.indexOf(_.map(_.get(user, 'data.data.payload.suppliers', []), item => item.code.toString()), selectedAgreement.destSupplierId) > -1;
    return (
      <MainLayout>
        {loading ? (
          <Loader/>
        ) : (
          <React.Fragment>
            <Row>
              {(isAgreementOwner || isAgreementSupplier) && <AlignRightColumn span={24}>
                {(isPm || (isAm && asProposal)) && isDraft && (
                  <Popconfirm
                    title={<div><div>Si è sicuri di voler procedere con l'invio al fornitore?</div></div>}
                    onConfirm={() => this.sendToSupplier()}
                    onCancel={() => {}}
                    okText="Conferma" cancelText="Cancella">
                    <Button>
                      Invia al fornitore
                    </Button>
                  </Popconfirm>
                )}
                {((isSupplier && isOpenWaiting) || ((isPm || (isAm && asProposal)) && isOpenApproved)) && (
                  <Button onClick={this.openModal}>Gestione accordo</Button>
                )}
                <Link to={`/edit/${selectedAgreement.agreementId}`}>
                  <MarginLeftButton
                    disabled={
                      ((((isAm && asProposal) || isPm) && !isDraft)
                          || (isSupplier && !isOpenWaiting)
                      )
                    }
                    type="primary">
                    Modifica
                  </MarginLeftButton>
                </Link>
              </AlignRightColumn>
              }
              <Col span={24}>
                <Divider/>
              </Col>
              <Summary data={selectedAgreement} user={user}/>
            </Row>
            {this.canSeePurposes() &&
            <Purpose user={this.props.user} onChangeCallback={(values, save) => this.updatePurpose(values, save)}
                     proposals={selectedAgreement.proposals} selectedAgreement={selectedAgreement} updateConnections={this.updateConnections.bind(this)}/>}
          </React.Fragment>
        )}
        <HandleAgreementModal
          user={user}
          visible={isModalOpen}
          onOkCallback={this.handleAgreement}
          onCancelCallback={this.closeModal}
        />
      </MainLayout>
    )
  }
}

const mapStateToProps = state => {
  return {
    selectedAgreement: state.Agreement.selectedAgreement,
    user: state.User
  }
}

const mapDispatchToProps = {
  updateSelectedAgreement,
  updateAgreementPurposes,
  updateSelectedRefs,
  updateUser
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Agreement)



// WEBPACK FOOTER //
// ./src/containers/Agreement/index.js